<header class="page-header-large">
  <div class="container-fluid">
    <div class="text-center d-flex justify-content-between align-items-center">
      <a><img src="assets/images/satyamev_jayate-blue.png" alt="CWMI"></a>
      <!-- class="logo_gec handpointer" -->
      <!-- <a *ngIf="specificLang == 'en' " (click)="!isActive['gis']?redirectGis():''"
        class="img-responsive handpointer"><img src="assets/images/nmcglogo_2.png" alt="cgwb"></a> -->

      <a *ngIf="specificLang == 'en' " class="en-main-title">
        <!-- <img class="main-title" src="assets/images/logo-nmcg-english.svg" alt="cgwb"> -->

        <h5 class="mb-0">National Mission for Clean Ganga</h5>
        <p class="mb-0">Department of Water Resource, River Development & Ganga Rejuvenation Ministry of Jal Shakti,
          Government of
          India</p>
      </a>
      <!-- class="img-responsive handpointer" -->

      <a *ngIf="specificLang != 'en' "><img src="assets/images/logo-nmcg-hindi.svg" alt="cgwb"></a>
      <!-- class="img-responsive handpointer" -->



      <a (click)="!isActive['gis']?redirectGis():''"><img src="assets/images/nmcgGif.gif" alt="CWMI"
          class="gif-image"></a>
    </div>
  </div>
  <div class="header_nav">
    <!-- <div class="btn-group head-costomtitle" >
                <b>COMPOSITE WATER MANAGEMENT INDEX - CWMI 4.0 &nbsp;&nbsp;&nbsp;&nbsp;</b>
            </div> -->
    <!-- <div class="btn-group mr-3" role="group" aria-label="Basic example">
               
            </div> -->


    <div class="row w-100 m-md-0 m-sm-0">
      <!-- <div class="my-2">
                    <div class="d-flex text-bold"  >
                        <div style="font-size: 12px; margin: 0px; padding:0px ;line-height:0px;" >Project status: </div> <a  style="color:white; font-size: 12px; line-height:0px; margin: 0px; padding:0px" href=" https://gisnmcg.mowr.gov.in/pmt/nmcgdashboard.aspx">https://gisnmcg.mowr.gov.in/pmt/nmcgdashboard.aspx</a>
                    </div>
                    <div class="d-flex">
                        <p style="font-size: 12px;" >Project Details:</p> <a style="color:white;font-size: 12px;" href="https://gisnmcg.mowr.gov.in/pmt/nmcgpmtmain.aspx ">https://gisnmcg.mowr.gov.in/pmt/nmcgpmtmain.aspx</a>
                    </div>
                </div> -->
      <!-- <div *ngIf="isActive['mis']" class="btn col-3">
        <button (click)="!isActive['gis']?redirectGis():''">
          {{'submitdata.Home' | translate}}
        </button>

      </div> -->
      <div class="col-12 col-xl-3">
        <div class="d-flex">
          <div class="mx-1 w-100">
            <select [(ngModel)]="selectedLanguage" class="form-control custom-selectbox text-dark w-100 pointer"
              (change)="getLanguageFile(selectedLanguage);">
              <option value="undefined" disabled>{{'header.About DGC' | translate}}</option>
              <option *ngFor="let  data of downloadflag |keyvalue" value="{{data['key']}}">
                {{'header.' +data['value'] | translate}}</option>
            </select>
          </div>
          <div class="mx-1 w-100">
            <p class="header_WN m-0 w-100" *ngIf="logedIn">
              <img src="assets/images/bell_yellow.png" class="bell-icon">
              <a class="pointer content_WN text-nowrap" (click)="redirectWhatsNew()">{{ 'broadcasting.whatsnew' | translate }}</a>
              <img src="assets/images/new_icon.jpg" class="new-icon" *ngIf="showNewIcon">
            </p>
          </div>
        </div>
      </div>
      <!-- <div style="width: 15%;">  -->
      <!-- [style.width]="isActive['mis'] ? '12%' : '15%'" -->

      <div class="col-12 col-xl-6">
        <div class="d-flex align-items-center justify-content-center">
          <div class="title">
            {{'header.title' | translate}}
          </div>
        </div>
      </div>


      <!-- <video width="300px" height="300px" controls="controls">
          <source src="assets/images/compressed merged video.mp4" type="video/mp4">
        </video> -->

      <div class="col-12 col-xl-3">
        <div class="d-flex align-items-center justify-content-xl-end  justify-content-between">
          <div class="btn-group" role="group" aria-label="Basic example">
            <button *ngIf="logedIn" class="btn btn-outline-primary mx-1" (click)="openVideoPopup()"
              title="Tutorial Video"><img src="assets/images/play.png" width="20" height="20"></button>
            <a href="https://gisnmcg.mowr.gov.in/pmt/nmcgdashboard.aspx" target="_blank" type="button"
              class="btn btn-primary btn-sm" data-toggle="tooltip" title="Project Status" data-placement="bottom"
              data-original-title="Project Status">
              <img src="assets/images/status.png" width="20" height="20" style="filter: invert(100%);" />
            </a>
            <!-- <button type="button" class="btn btn-primary">Middle</button> -->
            <a href="https://gisnmcg.mowr.gov.in/pmt/nmcgpmtmain.aspx" target="_blank" type="button"
              class="btn btn-primary btn-sm" data-toggle="tooltip" title="Project Details" data-placement="bottom"
              data-original-title="Project Details">
              <img src="assets/images/details.png" width="20" height="20" style="filter: invert(100%);" />
            </a>
          </div>
          <button *ngIf="specificLang == 'en'" class="btn btn-outline-primary mx-1"
            (click)="useLanguage('hi')">हिन्दी</button>
          <button *ngIf="specificLang != 'en'" class="btn btn-outline-primary mx-1"
            (click)="useLanguage('en')">English</button>
          <div>

          </div>
          <div class="btn-group" role="group" aria-label="Basic example">
            <a [ngClass]="{'highlight':isActive['gis']}" [ngClass]="disabled"
              (click)="!isActive['gis']?redirectGis():''" type="button" class="btn btn-primary" data-toggle="tooltip"
              title="GIS View" data-placement="bottom" data-original-title="GIS View"><i class="fa fa-globe"
                aria-hidden="true" name="gisview"></i></a>
            <a [ngClass]="{'highlight':isActive['mis']}" (click)="!isActive['mis']?redirectmis():''" type="button"
              class="btn btn-primary" data-toggle="tooltip" title="MIS View" data-placement="bottom"
              data-original-title="MIS View"><i class="fa fa-table" aria-hidden="true" name="mis"></i></a>
            <a [ngClass]="{'highlight':isActive['submitdata']}"
              (click)="!isActive['submitdata']?redirectToSubmitData():''" type="button" class="btn btn-primary"
              data-toggle="tooltip" title="Submit  Data" data-placement="bottom" data-original-title="Submit Data"><i
                class="fa fa-edit" aria-hidden="true" name="submitdata"></i></a>
          </div>

          <div class="btn-group ml-2">
            <span (click)="openloginpopup()" [hidden]="isUserLogin" data-toggle="tooltip"
              title="{{'header.login' | translate}}" data-placement="bottom" data-original-title="Login"><a
                class="btn btn-primary" data-toggle="modal"><span
                  class="hide-in-lg mr-2">{{'header.login' | translate}}</span><i class=" fa fa-lock"
                  aria-hidden="true"></i></a></span>

            <div *ngIf="isUserLogin" ngbDropdown class="d-inline-block ml-auto">
              <button class="btn btn-primary" id="sortMenu" ngbDropdownToggle><i class="fa fa-user"
                  aria-hidden="true"></i></button>
              <div class="dropdown-menu" style="transform:translate(-10px, 32px)!important" aria-labelledby="sortMenu"
                ngbDropdownMenu>
                <button class="dropdown-item" *ngFor="let options of userDropdownOptions"
                  (click)="getDropdownOptions(options)">{{'header.' +options | translate}}</button>
                <!-- <button class="dropdown-item" >{{this.userdetail['loggedUserData']['userProfile']['locationName']}}</button> -->
                <button class="dropdown-item"
                  *ngIf="userdetail['roles'][0] == 'DISTRICT_GANGA_COMMITTEE' ">{{"districtsdata." +loginDetail | translate}}
                  ({{'header.DGC' | translate}})</button>
                <!-- <button class="dropdown-item " (click)="ProfileForm()"
                  *ngIf="userdetail['roles'][0] == 'DISTRICT_GANGA_COMMITTEE' ">{{'header.addnodal' | translate}}</button> -->
                <button class="dropdown-item"
                  *ngIf="userdetail['roles'][0] == 'DISTRICT_VALIDATE_MEMBER' ">{{"districtsdata." +loginDetail | translate}}
                  ({{'header.DGC VA' | translate}})</button>
                <button class="dropdown-item text-wrap"
                  *ngIf="userdetail['roles'][0] == 'STATE_GANGA_COMMITTEE' ">{{'tabledataforstates.' +loginDetail | translate}}
                  {{'header.STATE ADMIN(SGC)' | translate}}</button>
                <button class="dropdown-item text-wrap"
                  *ngIf="userdetail['roles'][0] == 'ADMIN' && userdetail['usernameid'] == 'nmcg_admin'">{{'header.NMCG ADMIN' | translate}}</button>
                <button class="dropdown-item text-wrap"
                  *ngIf="userdetail['roles'][0] == 'ADMIN' && userdetail['usernameid'] == 'Ed_admin'">{{'header.Ed ADMIN' | translate}}</button>
                  <button class="dropdown-item"
                  *ngIf="userdetail['roles'][0] == 'MISCELLANEOUS_USER'">{{"header." +loginDetail | translate}}</button>
              </div>
            </div>


            <div class="d-inline-block" *ngIf="showbellicon">
              <a class="notification">
                <button [disabled]="disablebell" class="btn btn-info" (click)="enablenotifications()"><i
                    class="fa fa-bell"></i></button>
                <span class="badge" *ngIf="notificationcount!=0">{{notificationcount}}</span>
              </a>


              <div class="dropdown-menu notification-toggle mb-1" style="background-color: white;"
                [style.height]="!showlessnotifications ? '680px' : ''"
                [style.display]="shownotifications  ? 'block' : ''">
                <button class="dropdown-item notification" *ngFor="let notification of notifications"
                  [style.background-color]="notification['actionType'] == 'REJECT' ? '#ef5656' : '#d7d748'">{{notification.message}}</button>
                <button class="dropdown-item notification" *ngIf="showlessnotifications && !dontshowbtnsfornf"
                  (click)="viewallnotifications()">View All</button>
                <button class="dropdown-item notification" *ngIf="!showlessnotifications && !dontshowbtnsfornf"
                  (click)="viewlessnotifications()">View less</button>
              </div>
            </div>
          </div>
        </div>
        <!-- <div ngbDropdown class="d-inline-block mr-1">
                        <button class="btn btn-primary" id="dropdownBasic1" ngbDropdownToggle><i
                                class="fa fa-download" aria-hidden="true"></i></button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                            <button  (click)="pdfDownload()"
                                ngbDropdownItem>Authority Notification</button>
                            <button href="javascript:void(0)" ngbDropdownItem>User Manual</button>
                        </div>
                    </div> -->
      </div>


    </div>



    <!-- <span (click)="openloginpopup()" [hidden]="isUserLogin" data-toggle="tooltip" title="Login" data-placement="bottom" data-original-title="Login" class="">
                <a class="btn btn-info pointer" data-toggle="modal">Login <i class="fa fa-lock" aria-hidden="true"></i></a>
            </span> -->
    <ng-template #videoModal>
      <div class="modal-header border-0 m-0">
        <h2 style="text-align:center">GDPMS Tutorial</h2>
        <button type="button" (click)="CloseVideoModal()" class="close" aria-label="Close">
          <span aria-hidden="true" class="text-dark">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-x"
              viewBox="0 0 16 16">
              <path
                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </span>
        </button>
      </div>
      <div class="modal-body p-0">
        <video src="assets/images/compressed_merged_video.mp4" width="580px" height="325px" controls="true"
          class="video"></video>
      </div>
    </ng-template>

  </div>
</header>
